export enum PlanFeatureCategory {
  General = 'General',
  ContactManagement = 'ContactManagement',
  CrmIntegrations = 'CrmIntegrations',
  Analytics = 'Analytics',
  Compliance = 'Compliance',
  SSO = 'SSO',
  Support = 'Support',
}
